import { render } from "./ALeft.vue?vue&type=template&id=4380485c"
import script from "./ALeft.vue?vue&type=script&lang=js"
export * from "./ALeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__